<template>
  <div id="detail_decor" class="w-full h-full px-5 pt-6">
    <div id="top_bar" class="h-1/10 items-start">
      <div id="back"
           class="text-left col-span-2  col-start-1 row-start-1 lg:col-span-1 lg:col-start-1">
        <button
          class="title classen__rounded_full hover__button bg-white w-full md:w-1/3 lg:w-2/3 border-classen__primary border-2 text-left"
          @click="close"><i class="fas fa-angle-left"></i> {{ getTranslation(backTo) }}
        </button>
      </div>

      <div id="tabs"
           class="flex col-span-2 col-start-1 row-start-1 lg:col-start-2 text-xl">
        <p class="mr-4 pb-2" @click="currentTab = 0"
           :class="{'border-b-4 border-classen__primary': currentTab === 0, 'text-gray-500': currentTab === 1}">
          {{ getTranslation('generalInformation') }}
        </p>
        <p class="pb-2" @click="currentTab = 1"
           :class="{'border-b-4 border-classen__primary': currentTab === 1,'text-gray-500': currentTab === 0}">
          {{ getTranslation('downloads') }}
        </p>
      </div>

      <div id="selection"
           class="text-right flex justify-end row-start-1 col-start-3 justify-items-end xl:grid-cols-2">
        <p class="leading-none m-0 label" v-if="isCopied"><img class="ml-2"
                                                               src="../../../assets/icons/checkmark.svg"
                                                               alt="checkmark"> URL copied </p>
          <!-- TODO: re-enable -->
        <button v-if="false" class="classen__button copy_button" @click="copyUrl">
          <img src="../../../assets/icons/copy_blue.svg">
        </button>
        <button v-if="currentTab === 1"
                @click="downloadAll"
                class="downloadAll hover__button classen__rounded_full classen__button w-2/3">
          <label v-if="!isGeneratingExport">{{ getTranslation('downloadAll') }}</label>
          <c-loader v-if="isGeneratingExport" :inline="true" :bg-blur="false"
                    class="transform scale-50"></c-loader>
        </button>
        <c-selection class="ml-2 w-full cSelection" :mode="'decor'" :decor="decor" :isDetail="true"
                     :selected-selection="activeSelection"
                     v-if="displayQuickSelection"
                     @removeSelectionFromProduct="removeSelectionFromDecor"
                     @addSelectionToProduct="addToSelection"
        />
      </div>
    </div>

    <div id="decor_form" class="h-9/10 mt-5 lg mx-auto">
      <c-decor-form :show-links="showLinks" :class="{'hidden': currentTab!==0}" class="col-start-2"
                    :decor="decor"/>
      <c-download-form :class="{'hidden': currentTab!==1}" class="col-start-2" :assets="decorAssets"
                       :decor="decor"/>
    </div>

    <c-confirm v-if="isConfirmCloseVisible"
               :cancel-text="getTranslation('cancel')"
               :confirm-text="getTranslation('yesLeave')"
               :phrase="getTranslation('confirmCloseOnDownload')"
               @cancel="isConfirmCloseVisible = false"
               @confirm="$emit('close')"
    />
  </div>
</template>

<script>
import getTranslation from "../../../mixins/getTranslation";
import SelectionDropdown from "../SelectionDropdown";
import Button from "../../Button";
import DecorDetailForm from "./DecorDetailForm";
import DecorDownloadForm from "./DecorDownloadForm";
import download from "../../../mixins/download";
import Loader from "../../Loader";
import ConfirmationPopup from "../../form/ConfirmationPopup";

export default {
  name: "DecorDetail",

  components: {
    Button,
    'c-decor-form': DecorDetailForm,
    'c-selection': SelectionDropdown,
    'c-download-form': DecorDownloadForm,
    'c-loader': Loader,
    'c-confirm': ConfirmationPopup
  },

  mixins: [getTranslation, download],

  props: {
    decor: {required: true},
    activeSelection: {required: true},
    displayQuickSelection: {required: false, default: true},
    backTo: {required: false, type: String, default: 'backToDecors'},
    showLinks: {required: false, type: Boolean, default: true}
  },

  data() {
    return {
      currentTab: 0,
      decorAssets: [],
      isGeneratingExport: false,
      isConfirmCloseVisible: false,
      isCopied: false,
    }
  },

  created() {
    this.decorAssets = this.decor.decorAssets
  },

  methods: {
    close() {
      if (this.isGeneratingExport) {
        this.isConfirmCloseVisible = true;
        return
      }

      this.$emit('close');
    },

    downloadAll() {
      if (this.isGeneratingExport) {
        return
      }

      this.isGeneratingExport = true;
      let urls = {};
      this.decorAssets.forEach((asset, index) => {
        urls[`${index + 1}_${asset.type}.jpg`] = asset.asset;
      });

      this.$dashboardStore.dispatch('getImageZip', {images: urls, name: `${this.decor.name}.zip`})
        .then((res) => {
          this.downloadFile(res.url);
          this.isGeneratingExport = false;
          this.isConfirmCloseVisible = false;
        })
    },

    removeSelectionFromDecor(selection) {
      this.$dashboardStore.dispatch('removeDecorFromSelection', {
        selectionId: selection.id,
        decorId: this.decor.id
      }).then(() => {
        this.decor.selections = this.decor.selections.filter((sel) => {
          return sel.id !== selection.id
        })
      })
    },

    addToSelection(selection = null) {
      if (selection === null) {
        this.$dashboardStore.dispatch('addDecorToSelection', {
          decorId: this.product.id,
          selectionId: this.selectedSelection.id
        })
          .then(() => {
            this.decor.selections.push(this.selectedSelection)
          });
      } else {
        this.$dashboardStore.dispatch('addDecorToSelection', {
          decorId: this.decor.id,
          selectionId: selection.id
        })
          .then(() => {
            this.decor.selections.push(selection)
          });
      }
    },

    copyUrl() {
      const basePath = window.location.host
      const protocol = window.location.protocol
      const url = `${protocol}//${basePath}/#/decor/${this.decor.number}`;
      navigator.clipboard.writeText(url);
      this.isCopied = true;
    }
  }
}
</script>

<style scoped>
#tabs > label {
  height: 25px;
  width: fit-content;
}

#top_bar, #decor_form {
  display: grid;
  grid-template-columns: 18% 58% 24%;
}

.downloadAll {
  padding-left: 0;
  height: 40px;
  line-height: 40px;
}

.cSelection {
  width: 200px
}

#back {
  width: 250px !important
}

.copy_button {
  width: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.copy_button > img {
  width: 22px;
  height: 22px;
}

.label {
  display: flex;
  height: 42px;
  line-height: 42px;
  @apply mr-2 text-classen__primary;
}

.label > img {
  height: 20px;
  margin-top: 11px;
}
</style>
